module.exports = __webpack_public_path__ + "src/images/begin-step-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/begin-step-1.jpg
// module id = 1136
// module chunks = 0